/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigService, LocalStorageService, WRAdminGuard } from '@windriver/authentication';

// Central location for getting information about the logged in user.
// Currently makes no service calls, but does inspect their access token.
@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  private apiBackendBaseUrl: string;
  private impersonationRole: string;

  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    private localstorageService: LocalStorageService,
    private wrAdminGuard: WRAdminGuard,
    private http: HttpClient,
    private configService: ConfigService // apiBackendBaseUrl = environment.apiUrl
  ) {
    this.configService.configState.subscribe((config: any) => {
      // this.apiBackendBaseUrl = config.apiUrl;
      if (config) {
        this.apiBackendBaseUrl = config.apiUrl;
        this.impersonationRole = config.impersonationRoleName;
      }
    });
  }

  public getUsername(): string {
    return this.localstorageService.getItem('user').username;
  }

  public hasAdminRole(): boolean {
    return this.hasRole(this.wrAdminGuard.adminRole);
  }

  public isExternal(): boolean {
    return this.hasRole('External');
  }

  public isInternal(): boolean {
    return this.hasRole('Internal');
  }

  public hasImpersonate(): boolean {
    return this.hasRole(this.impersonationRole);
  }

  public isAdmin(): boolean {
    return this.hasRole('glmsAdmin');
  }

  public hasRole(role: string): boolean {
    return this.localstorageService.getItem('roles').some((r) => r.name === role);
  }

  public getUserRole() {
    return this.http
      .get<any>(this.apiBackendBaseUrl + `/v1/tools/tozny/role/${this.getUsername()}`, this.httpOptions)
      .pipe(catchError((error) => throwError(`Error getting role: ${JSON.stringify(error)}`)));
  }
}
